import { render, staticRenderFns } from "./PayPalTest.vue?vue&type=template&id=fb637c7c"
import script from "./PayPalTest.vue?vue&type=script&lang=js"
export * from "./PayPalTest.vue?vue&type=script&lang=js"
import style0 from "./PayPalTest.vue?vue&type=style&index=0&id=fb637c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports